let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("58Dhx")).then(() => parcelRequire('kkdRQ'));